(function (w, d, f) {
  w.Produktly =
    w.Produktly ||
    new Proxy(() => {}, {
      get: function (_, n) {
        return (...a) => {
          w.ProduktlyQ = (w.ProduktlyQ || []).concat([[n, a]]);
        };
      },
      apply: function (_, __, a) {
        w.ProduktlyQ = (w.ProduktlyQ || []).concat([['apply', a]]);
      },
    });
  var a = d.getElementsByTagName('head')[0];
  var s = d.createElement('script');
  s.async = 1;
  s.src = f;
  s.setAttribute('id', 'produktlyScript');
  s.dataset.clientToken =
    '46f6fc7c86d4b2bc1ce5ddb45080e9803fffd5d0014a6dd579f61b1c296c9b8c19ca495a27d22d8eddcb6119c99bcad69ea3526917ae2e37aca337c089c26df86533932c6e758beb7062b55871e0cb2706029050ec98cec3ec3f295093d30cb4a0de819f';
  a.appendChild(s);
})(window, document, 'https://public.produktly.com/js/main.js');
